import { render } from "./InputFile.vue?vue&type=template&id=436d945c"
import script from "./InputFile.vue?vue&type=script&lang=js"
export * from "./InputFile.vue?vue&type=script&lang=js"

import "./InputFile.vue?vue&type=style&index=0&id=436d945c&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__